{
  // const accordionSections = document.querySelectorAll(".accordion");

  // accordionSections.forEach((section) => {
  //   const accordionItemHeaders = section.querySelectorAll(
  //     ".accordion-item-header"
  //   );

  //   if (accordionItemHeaders.length > 0) {
  //     const firstAccordionItemHeader = accordionItemHeaders[0];
  //     const firstAccordionItemBody =
  //       firstAccordionItemHeader.nextElementSibling;

  //     firstAccordionItemHeader.classList.add("active");
  //     firstAccordionItemBody.style.maxHeight =
  //       firstAccordionItemBody.scrollHeight + "px";
  //   }

  //   accordionItemHeaders.forEach((accordionItemHeader) => {
  //     accordionItemHeader.addEventListener("click", (event) => {
  //       const accordionItemBody = accordionItemHeader.nextElementSibling;
  //       accordionItemHeaders.forEach((item) => {
  //         if (item !== accordionItemHeader) {
  //           item.classList.remove("active");
  //           item.nextElementSibling.style.maxHeight = 0;
  //         }
  //       });
  //       accordionItemHeader.classList.toggle("active");
  //       if (accordionItemHeader.classList.contains("active")) {
  //         accordionItemBody.style.maxHeight =
  //           accordionItemBody.scrollHeight + "px";
  //       } else {
  //         accordionItemBody.style.maxHeight = 0;
  //       }
  //     });
  //   });
  // });

  const accordionSections = document.querySelectorAll(".accordion");

  accordionSections.forEach((section) => {
    const accordionItemHeaders = section.querySelectorAll(
      ".accordion-item-header"
    );

    if (accordionItemHeaders.length > 0) {
      const firstAccordionItemHeader = accordionItemHeaders[0];
      const firstAccordionItemBody =
        firstAccordionItemHeader.nextElementSibling;

      firstAccordionItemHeader.classList.add("active");
      firstAccordionItemBody.style.maxHeight =
        firstAccordionItemBody.scrollHeight + "px";
    }

    accordionItemHeaders.forEach((accordionItemHeader) => {
      accordionItemHeader.addEventListener("mouseover", () => {
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        accordionItemHeaders.forEach((item) => {
          if (item !== accordionItemHeader) {
            item.classList.remove("active");
            item.nextElementSibling.style.maxHeight = 0;
          }
        });
        accordionItemHeader.classList.add("active");
        accordionItemBody.style.maxHeight =
          accordionItemBody.scrollHeight + "px";
      });

      accordionItemHeader.addEventListener("mouseleave", () => {
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        accordionItemHeader.classList.remove("active");
        accordionItemBody.style.maxHeight = 0;
      });
    });
  });
}

{
  var swiper = new Swiper(".mySwiperone", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 10000,
  });
}
// {
//   var swiper = new Swiper(".product-slider", {
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     loop: true,
//     grabCursor: true,
//     autoplay: false,
//   });
// }

{
  document.addEventListener("DOMContentLoaded", function () {
    const menuToggle = document.getElementById("menu-toggle");
    const navbarMenu = document.querySelector(".abs-sec");

    menuToggle.addEventListener("click", function () {
      navbarMenu.classList.toggle("active");

      if (navbarMenu.classList.contains("active")) {
        menuToggle.innerHTML = "&#10006;";
        navbarMenu.style.display = "block";
      } else {
        menuToggle.innerHTML = "&#9776;";
        navbarMenu.style.display = "none";
      }
    });
  });
}
// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const section = document.querySelector(".navigate__row");

//     function checkSectionInView() {
//       const rect = section.getBoundingClientRect();
//       const windowHeight = window.innerHeight;

//       if (rect.top <= windowHeight && rect.bottom >= 0) {
//         section.classList.add("animated");
//       } else {
//         section.classList.remove("animated");
//       }
//     }

//     window.addEventListener("scroll", checkSectionInView);

//     checkSectionInView();
//   });
// }
{
  document.addEventListener("DOMContentLoaded", () => {
    const headers = document.querySelectorAll(".accordion-header-products");

    headers.forEach((header) => {
      header.addEventListener("click", () => {
        const content = header.nextElementSibling;

        // Toggle the clicked content
        if (content.style.display === "block") {
          content.style.display = "none";
        } else {
          content.style.display = "block";
        }
      });
    });
  });
}
